import { categories } from '@/mocks/categories';
import { Link } from 'react-router-dom';

export default function CategorySection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
            探索<span className="text-accent-500">漫画</span>分类
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mt-3">
            无论你喜欢什么类型，这里都有你的最爱
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-xl bg-background-100 hover:bg-accent-50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center group-hover:bg-accent-200 transition-colors duration-300">
                <i className={`${cat.icon} text-accent-600 text-xl w-5 h-5 flex items-center justify-center`}></i>
              </div>
              <span className="text-sm font-semibold text-foreground-800 whitespace-nowrap">{cat.name}</span>
              <span className="text-xs text-foreground-500">{cat.description}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}